Object.defineProperty(exports, '__esModule', {
  value: true
});
var dateFns = require('date-fns');
var startOfWeekUK = function startOfWeekUK(date) {
  return dateFns.startOfWeek(date, {
    weekStartsOn: 1
  });
};
exports.startOfWeekUK = startOfWeekUK;